<div class="tt-coding-system-selector_codings">
  @for (coding of _codings(); track coding.id) {
    @if (currentlyEditing()?.id === coding.id) {
      <form #ttCodingSystemSelectorForm="ngForm" class="tt-coding-system-selector_codings-form">
        <tt-form-field>
          <label ttLabel>System</label>
          <tt-select
            data-testid="coding-systems-selector_system-select"
            name="system"
            required
            [(ngModel)]="currentlyEditing().systemId"
            (ngModelChange)="handleSystemChanged()">
            <tt-select-items>
              @for (codingSystem of codingSystemsMap().values(); track codingSystem.id) {
                <tt-option [attr.data-testid]="'coding-systems-selector_system-id-' + codingSystem.id" [value]="codingSystem.id">
                  {{ codingSystem.title }}
                </tt-option>
              }
            </tt-select-items>
          </tt-select>
        </tt-form-field>
        <tt-form-field>
          <label ttLabel>Version</label>
          <tt-select
            data-testid="coding-systems-selector_version-select"
            name="version"
            required
            [disabled]="!codingSystemsMap()?.get(coding.systemId)"
            [(ngModel)]="currentlyEditing().versionId">
            <tt-select-items>
              @for (version of codingSystemsMap()?.get(currentlyEditing().systemId)?.versions; track version.id) {
                <tt-option [attr.data-testid]="'coding-systems-selector_version-' + version.id" [value]="version.id">
                  {{ version.name }}
                </tt-option>
              }
            </tt-select-items>
          </tt-select>
        </tt-form-field>

        <tt-form-field>
          <label ttLabel>Code</label>
          <input
            data-testid="coding-systems-selector_code"
            name="code"
            required
            ttInput
            [disabled]="!codingSystemsMap()?.get(coding.systemId) && !currentlyEditing().versionId"
            [(ngModel)]="currentlyEditing().code" />
          <tt-error>{{ 'Validation.FieldRequired' | transloco }}</tt-error>
        </tt-form-field>
      </form>
      <div class="tt-coding-system-selector_edit-actions">
        <button data-testid="coding-systems-selector_cancel-button" ttButton [variant]="'secondary'" (click)="handleCancel()">
          <span>{{ 'Cancel' | transloco }}</span>
        </button>
        @if (currentlyEditing().id) {
          <button data-testid="coding-systems-selector_add-medical-code-button"
            ttButton
            [disabled]="!ttCodingSystemSelectorForm.valid"
            [variant]="'primary'"
            (click)="handleCodingEdited()">
            <span>{{ 'Add' | transloco }}</span>
          </button>
        } @else {
          <button data-testid="coding-systems-selector_add-medical-code-button"
            ttButton
            [disabled]="!ttCodingSystemSelectorForm.valid"
            [variant]="'primary'"
            (click)="handleCodingAdded()">
            <span>{{ 'Add' | transloco }}</span>
          </button>
        }
      </div>
    } @else {
      @if (codingSystemsMap()?.get(coding.systemId); as codingSystem) {
        <div class="tt-coding-system-selector_codings-coding">
          <span class="tt-coding-system-selector_codings-coding-header">
            <span class="tt-coding-system-selector_codings-coding-label">
              {{ 'CodingSystems.' + codingSystem.name | transloco }}
              <mat-icon
                [icon]="'info'"
                [iconSize]="12"
                [ttTooltip]="
                  ('CodingSystems.' + codingSystem.name + '_Tooltip' | transloco) + ', ' + ('Version' | transloco) + ': ' + coding.versionId
                " />
            </span>
            <span class="tt-coding-system-selector_codings-coding-value">
              {{ coding.code }}
            </span>
          </span>

          @if (!currentlyEditing()) {
            <div class="tt-coding-system-selector_codings-coding-actions">
              <button class="tt-tree_node-actions-item" ttButton [size]="'icon'" [ttMenuTriggerFor]="menu" [variant]="'transparent'">
                <mat-icon [icon]="'three-dots-horizontal'" [iconSize]="16" />
              </button>

              <tt-menu #menu>
                <button ttMenuItem (click)="currentlyEditing.set(coding)">
                  <mat-icon [icon]="'pencil'" [iconSize]="14" />
                  {{ 'Edit' | transloco }}
                </button>
                <button ttMenuItem (click)="handleRemoveCoding(coding)">
                  <mat-icon [icon]="'trash'" [iconSize]="14" />
                  {{ 'Delete' | transloco }}
                </button>
              </tt-menu>
            </div>
          }
        </div>
      }
    }
  }
  @if (_codings().length === 0) {
    <div class="tt-coding-system-selector_no-codings">
      {{ 'Sidebar.Header.CodingSystemSelector.NoCodings' | transloco }}
    </div>
  }
  @if (!currentlyEditing()) {
    <div class="tt-coding-system-selector_actions">
      <button data-testid="coding-systems-selector_add-medical-code-button" ttButton [variant]="'primary'" (click)="createCoding()">
        <span>{{ 'Add' | transloco }}</span>
      </button>
    </div>
  }
</div>
